import Select from "kreate-common/modules/kreate-ui/components/Select";
import * as React from "react";
import { z } from "zod";

export const MintStatus = z.enum(["available_for_minting", "sold_out", "all"]);

export type MintStatus = z.infer<typeof MintStatus>;

type MintStatusItems = {
  [name in MintStatus]: {
    label: string;
  };
};

export const mintStatusItems: MintStatusItems = {
  available_for_minting: {
    label: "For Sale",
  },
  sold_out: {
    label: "Sold Out",
  },
  all: {
    label: "All",
  },
};

type Props = {
  className?: string;
  style?: React.CSSProperties;
  value: MintStatus;
  onChange: (value: MintStatus) => void;
  disabled?: boolean;
};

export default function Select$MintStatus({
  className,
  style,
  value,
  onChange,
}: Props) {
  return (
    <div className={className} style={style}>
      <Select
        value={value}
        onChange={onChange}
        options={Object.entries(mintStatusItems).map(([value, { label }]) => ({
          // NOTE: Object.entries always return `string` for the key parameter.
          // However in this case its type has to be MintStatus
          value: value as MintStatus,
          label,
        }))}
        minButtonWidth="160px"
        minContentWidth="220px"
      />
    </div>
  );
}
